// lifecycle_tag_to_description = {
//   "case_setup": "1 – Setup",
//   "information_gathering": "2 – Gather information",
//   "investigation": "3 – Send contract pack, check the title and offer",
//   "enquiries_ongoing": "4 – Resolve enquiries",
//   "approaching_exchange": "5 – Resolve final enquiries",
//   "ready_to_exchange": "6 – Exchange (or submit CoT)",
//   "approaching_completion": "7 – Complete",
//   "post_completion": "8 – Apply to register",
//   "wrapping_up": "9 – Send the registered title to client and lender, close the case",
// }

// Phase 6 - all enquiries resolved
// Phase 5 - 1-3 enquiries remaining
// Phase 4 - 4+ enquiries remaining
// Phase 3 - [whatever we had before]
// Phase 2 - [whatever we had before]
// Phase 1 - case setup

export const LIFECYCLE_TAGS = {
  pre_memo: {
    // tags ignored - looks for milestones.memorandum_of_sale_received === null
    tags: [],
    name: "Pre-MOS",
  },
  all_cases: {
    tags: [
      "case_setup",
      "information_gathering",
      "investigation",
      "enquiries_ongoing",
      "approaching_exchange",
      "ready_to_exchange",
    ],
    name: "All active cases",
  },
  exchanged: {
    tags: ["approaching_completion"],
    name: "Exchanged cases",
  },
  completed: {
    tags: ["post_completion", "wrapping_up"],
    name: "Completed cases",
  },
};

// The estate agent dashboard's sidebar, in order. "cases" items filter the case list by the
// LIFECYCLE_TAGS entry of the same key; "referrals" is the leads list from /api/dashboard/referrals.
// LIFECYCLE_TAGS stays a case-filter concept: an unknown key there falls through to every case.
export const NAV_ITEMS = [
  { key: "referrals", name: "Referrals", kind: "referrals" },
  ...Object.entries(LIFECYCLE_TAGS).map(([key, { name }]) => ({ key, name, kind: "cases" })),
];

export const LIFECYCLE_TAG_DESCRIPTIONS = {
  tags: [
    { tag: "case_setup", description: "Case setup" },
    { tag: "information_gathering", description: "Gather information" },
    { tag: "investigation", description: "Contract pack" },
    { tag: "enquiries_ongoing", description: "4 + enquiries remaining" },
    { tag: "approaching_exchange", description: "1-3 enquiries remaining" },
    { tag: "ready_to_exchange", description: "All enquiries resolved" },
    { tag: "approaching_completion", description: "Approaching completion" },
    { tag: "post_completion", description: "Completed" },
    { tag: "wrapping_up", description: "Completed" },
  ],
};
